import { render, staticRenderFns } from "./CreateLimitTypeModal.vue?vue&type=template&id=251c9264&scoped=true"
import script from "./CreateLimitTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateLimitTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateLimitTypeModal.vue?vue&type=style&index=0&id=251c9264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c9264",
  null
  
)

export default component.exports